const ProjectIncomesIcon = () => {
  return (
    <svg viewBox="0 0 30 24.6">
      <g transform="translate(0 -19.84)">
        <path
          d="M3.6,19.84A3.61,3.61,0,0,0,0,23.44v17.4a3.61,3.61,0,0,0,3.6,3.6H30V22.84H7.078A3.563,3.563,0,0,0,3.6,19.84Zm0,1.2A2.393,2.393,0,0,1,6,23.44V38.168a3.567,3.567,0,0,0-4.8,0V23.44A2.393,2.393,0,0,1,3.6,21.04Zm3.6,3H28.8v19.2H3.6A2.4,2.4,0,1,1,6,40.84H7.2ZM21,27.64l1.676,1.676L19.5,32.491l-3.272-3.274L11.006,33.79l.788.9,4.378-3.827L19.5,34.188l4.024-4.024L25.2,31.84v-4.2ZM10.2,37.84v1.2h15v-1.2Z"
          transform="translate(0)"
        />
      </g>
    </svg>
  );
};

export default ProjectIncomesIcon;
